import { FC } from 'react'
import { IconButton, TextField, InputAdornment, Grid } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { toSpliced } from '../../../../utils/functions'

interface IProps {
  value: Array<[string, string]>
  onChange: (vals: Array<[string, string]>) => void
  className: string
  label: string
}

/*
 * Show a list of pairs of TextFields side-by-side. Each one uses a two-element array to hold the value.
 *
 * TODO: This should really be a List<TextFieldPair> or even better a List<Pair<Text, Text>>.
 */
const TextFieldPairList: FC<IProps> = ({
  value,
  onChange,
  className,
  label,
}) => {
  // Handle legacy single-line values:
  if (value.constructor !== Array)
    value = [['', (value as unknown as string) || '']]

  // Make sure we show at least one field:
  if (value.length === 0) value = [['', '']]

  return (
    <>
      {value?.map((line, i) => {
        return (
          <Grid key={i.toString()} container spacing={2}>
            <Grid item xs={6}>
              <TextField
                key="key"
                value={line[0] || ''}
                onChange={(ev) =>
                  onChange(toSpliced(value, i, 1, [ev.target.value, line[1]]))
                }
                className={className}
                label={label}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                key="value"
                value={line[1] || ''}
                onChange={(ev) =>
                  onChange(toSpliced(value, i, 1, [line[0], ev.target.value]))
                }
                className={className}
                label={label}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => onChange(toSpliced(value, i, 1))}
                      >
                        <RemoveIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        )
      })}
      <IconButton onClick={() => onChange([...value, ['', '']])}>
        <AddIcon />
      </IconButton>
      <br />
    </>
  )
}

export default TextFieldPairList
